import { render, staticRenderFns } from "./procesaCVS.vue?vue&type=template&id=29bbc3d2&scoped=true"
import script from "./procesaCVS.vue?vue&type=script&lang=js"
export * from "./procesaCVS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbc3d2",
  null
  
)

export default component.exports